module.exports = __webpack_public_path__ + "media/design-tools.a2b2a907341a6afb9ae5b5b39cc1f368.svg";